import List from 'antd/lib/list'

import 'antd/lib/list/style'

export * from 'antd/lib/list'

export default List
